import React, { useState } from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import { getUserByPhoneApi } from '../../utils/apisConsts';
import { AddReward } from './AddReward';
export const AddRewardsAction: React.FC = () => {
    const [componentSteps] = useState([
        {
            title: 'Get User',
            content: <GetInfo apiLink={getUserByPhoneApi} isApplyingPhoneAndID />,
            id: 0,
        },
        {
            title: 'Add Rewards',
            content: <AddReward />,
            id: 1,
        },
    ]);

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};

